/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Status_Scanning_MediaInputs */

const en_new_project_status_scanning_media = /** @type {(inputs: New_Project_Status_Scanning_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scanning Media`)
};

const fr_new_project_status_scanning_media = /** @type {(inputs: New_Project_Status_Scanning_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyse du media`)
};

const de_new_project_status_scanning_media = /** @type {(inputs: New_Project_Status_Scanning_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scanmedien`)
};

const it_new_project_status_scanning_media = /** @type {(inputs: New_Project_Status_Scanning_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scansione dei supporti`)
};

const ru_new_project_status_scanning_media = /** @type {(inputs: New_Project_Status_Scanning_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сканирование носителей`)
};

const es_new_project_status_scanning_media = /** @type {(inputs: New_Project_Status_Scanning_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medios de escaneo`)
};

const zh_cn2_new_project_status_scanning_media = /** @type {(inputs: New_Project_Status_Scanning_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`扫描介质`)
};

const ja_new_project_status_scanning_media = /** @type {(inputs: New_Project_Status_Scanning_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアのスキャン`)
};

const hi_new_project_status_scanning_media = /** @type {(inputs: New_Project_Status_Scanning_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्कैनिंग मीडिया`)
};

const pt_pt2_new_project_status_scanning_media = /** @type {(inputs: New_Project_Status_Scanning_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mídia de digitalização`)
};

/**
* | output |
* | --- |
* | "Scanning Media" |
*
* @param {New_Project_Status_Scanning_MediaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_status_scanning_media = /** @type {((inputs?: New_Project_Status_Scanning_MediaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Status_Scanning_MediaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_status_scanning_media(inputs)
	if (locale === "de") return de_new_project_status_scanning_media(inputs)
	if (locale === "it") return it_new_project_status_scanning_media(inputs)
	if (locale === "ru") return ru_new_project_status_scanning_media(inputs)
	if (locale === "es") return es_new_project_status_scanning_media(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_status_scanning_media(inputs)
	if (locale === "ja") return ja_new_project_status_scanning_media(inputs)
	if (locale === "hi") return hi_new_project_status_scanning_media(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_status_scanning_media(inputs)
	return en_new_project_status_scanning_media(inputs)
});